import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { serviceCenterStore } from 'App/ServiceCenter/store/serviceCenterStore'
import { apiFetch } from 'utils/apiFetch'

export type GatewayRemoveMeta = routes.ServiceCenterGatewayRemove.Request

export const request = async (param: GatewayRemoveMeta) => {
  await apiFetch({ url: '/service-center-gateway-remove', body: param })

  return param
}

export const callback = async (param: GatewayRemoveMeta) => {
  serviceCenterStore.actions.removeActiveNodes([param.gatewayIdentifier])
}

export const serviceCenterGatewayRemove = {
  request,
  callback,
}
